export let ViewableElement;

(function (ViewableElement) {
  ViewableElement["FacebookLikeButton"] = "facebook_like_button";
  ViewableElement["MyItemsGrid"] = "my_items_grid";
  ViewableElement["MyItemsList"] = "my_items_list";
  ViewableElement["MyFavoritesGrid"] = "my_favorites_grid";
  ViewableElement["MyFavoritesList"] = "my_favorites_list";
  ViewableElement["MeasurementsInfo"] = "measurements_info";
  ViewableElement["CatalogGrid"] = "catalog_grid";
  ViewableElement["CatalogList"] = "catalog_list";
  ViewableElement["NpsSurvey"] = "nps_survey";
  ViewableElement["SellTabSurvey"] = "sell_tab_survey";
  ViewableElement["SellerAfterUploadInstructions"] = "seller_after_upload_instructions";
  ViewableElement["SellerAfterSaleInstructions"] = "seller_after_sale_instructions";
  ViewableElement["SellerAfterTransactionCompleteInstructions"] = "seller_after_transaction_complete_instructions";
  ViewableElement["EmailConfirmation"] = "email_confirmation";
  ViewableElement["EmailConfirmed"] = "email_confirmed";
  ViewableElement["Video"] = "video";
  ViewableElement["SellerBanner"] = "seller_banner";
  ViewableElement["SellTabBanner"] = "sell_tab_banner";
  ViewableElement["SellerFunnelWelcomeSlide"] = "seller_funnel_welcome_slide";
  ViewableElement["WalletSetupSuccess"] = "wallet_setup_success";
  ViewableElement["WalletPayInSuccess"] = "wallet_pay_in_success";
  ViewableElement["NewsletterSubscriptionBanner"] = "newsletter_subscription_banner";
  ViewableElement["EditorialCampaignBanner"] = "editorial_campaign_banner";
  ViewableElement["CtaPrompty"] = "cta_prompt";
  ViewableElement["FeedPersonalizationBanner"] = "feed_personalization_banner";
  ViewableElement["PersonalizationBannerAfterFeed"] = "personalization_banner_after_feed";
  ViewableElement["AdBox"] = "ad_box";
  ViewableElement["BumpPromotion"] = "bump_promotion";
  ViewableElement["OnboardingModalCard"] = "onboarding_modal_card";
  ViewableElement["AppRatingDialog"] = "app_rating_dialog";
  ViewableElement["UploadOnboardingCarouselCard"] = "upload_onboarding_carousel_card";
  ViewableElement["Notification"] = "notification";
  ViewableElement["SeeWholeClosetCta"] = "see_whole_closet_cta";
  ViewableElement["CookieAndAdPersonalizationBanner"] = "cookie_and_ad_personalization_banner";
  ViewableElement["AdPersonalizationToggle"] = "ad_personalization_toggle";
  ViewableElement["ShippingPrice"] = "shipping_price";
  ViewableElement["TranslationHint"] = "translation_hint";
  ViewableElement["LocalSearchSuggestion"] = "local_search_suggestion";
  ViewableElement["BrandClusterSection"] = "brand_cluster_section";
  ViewableElement["PhotoPickerInfoBanner"] = "photo_picker_info_banner";
  ViewableElement["CrmMessageVideo"] = "crm_message_video";
  ViewableElement["FreeReturnLabelModal"] = "free_return_label_modal";
  ViewableElement["LabelTypeSelection"] = "label_type_selection";
  ViewableElement["PushUpOrderConfirmation"] = "push_up_order_confirm";
  ViewableElement["ReturnOrder"] = "return_order";
  ViewableElement["ShipFastBadgeDescription"] = "ship_fast_badge_description";
  ViewableElement["VideoStoryFeed"] = "video_story_feed";
  ViewableElement["VideoStory"] = "video_story";
  ViewableElement["PhysicalAuthenticityBuyerModal"] = "physical_auth_buyer";
  ViewableElement["OfflineVerificationSellerModal"] = "physical_auth_seller";
  ViewableElement["OfflineVerificationStatus"] = "physical_auth_eligible";
  ViewableElement["ValueSelectModal"] = "value_select_modal";
  ViewableElement["CtaPrompt"] = "cta_prompt";
})(ViewableElement || (ViewableElement = {}));